<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      align-center
      justify-center
      row
    >
      <v-dialog
        value="true"
        fullscreen
        content-class="sm-container"
      >
        <v-card class="text-center">
          <div
            v-if="!selectedSurvey"
            class="loading"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              class="loading-circle"
            />
          </div>
          <iframe
            v-else
            class="story-map"
            :src="selectedSurvey.story_map_url"
            frameborder="0"
            scrolling="yes"
          />
          <v-layout
            id="button"
            align-center
            justify-center
          >
            <v-btn
              id="redirect"
              class="white--text"
              color="#1A237E"
              rounded
              @click.native="toLookup"
            >
              Please Click Here to Take the Survey
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>


<script>
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState({
      surveys: state => state.survey.surveys,
    }),
    surveyParams() {
      const fromRouter = this.$router.currentRoute.params;
      const routerParams = {
        program_name: this.formatName(fromRouter.program_name),
        project_name: this.formatName(fromRouter.project_name),
        survey_name: this.formatName(fromRouter.survey_name)
      };
      return routerParams
    },
    selectedSurvey() {
      let programName = this.surveyParams.program_name
      let projectName = this.surveyParams.project_name
      let surveyName = this.surveyParams.survey_name
      const survey = this.surveys.find(survey => {
        if (survey.survey_metadata.meta_data.dashboardFiltering.program.toUpperCase() === programName.toUpperCase() &&
          survey.survey_metadata.meta_data.dashboardFiltering.project.toUpperCase() === projectName.toUpperCase() &&
          survey.survey_metadata.meta_data.dashboardFiltering.survey.toUpperCase() === surveyName.toUpperCase()) {
          return survey;
        }
      });
      return survey
    }
  },
  created() {
    this.fetchSurveys();
    this.toggleVirtualMeetingBoolean(true)
  },
  methods: {
    ...mapActions({
      fetchSurveys: "survey/fetchSurveys",
      toggleVirtualMeetingBoolean: "survey/toggleVirtualMeetingBoolean"
    }),
    formatName(name) {
      return (name).replace(/_/g, " ")
    },
    toLookup() {
      this.$router.push({
        name: "ViewSingleSurvey",
        params: this.$router.currentRoute.params
      })
    }
  }
};
</script>

<style scoped>
.story-map {
    width: 100%;
    height: 89vh;
}
#button {
    height: 10vh;
    background-color: #E0E0E0;
}
.loading {
  width: 100%;
  height: 89vh;
  justify-items: center;
}
.loading-circle {
  margin-top: 20%;
  width: 10% !important;
  height: 10% !important;
}
</style>